import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';

export default function TabPanel(props) {
  const { children, activeIndex, index, ...other } = props;

  return (
    <Typography component="div" role="tabpanel" hidden={activeIndex !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
      {activeIndex === index && <Box>{children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  activeIndex: PropTypes.any.isRequired,
};
